function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossRoundedGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19579",
    transform: "translate(-487 -177)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 625",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(487 177)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16308",
    d: "m8.551 6.666 4.39-4.39A1.333 1.333 0 1 0 11.056.391l-4.39 4.39-4.39-4.39A1.333 1.333 0 1 0 .391 2.276l4.39 4.39-4.39 4.39a1.333 1.333 0 1 0 1.885 1.885l4.39-4.39 4.39 4.39a1.333 1.333 0 1 0 1.885-1.885z",
    transform: "translate(498.834 188.834)",
    style: {
      fill: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRoundedGray);
export default __webpack_public_path__ + "static/media/cross-rounded-gray.dfcf7d6526204d6c9fd929a974e5537d.svg";
export { ForwardRef as ReactComponent };